// src/api/auth.js
// Thin wrappers over the /auth endpoints. Each returns the unwrapped data
// payload (res.data.data) or throws with a normalised { message, code }.

import client, { tokenStore } from "./client";

const unwrap = (res) => res.data.data;

// turn an axios error into { message, code } using the backend envelope
const normalizeError = (err) => {
  const body = err.response?.data;
  return {
    message: body?.error || "Something went wrong. Try again.",
    code: body?.code || "NETWORK",
    status: err.response?.status || 0,
  };
};

export const login = async (email, password) => {
  try {
    const data = unwrap(await client.post("/auth/login", { email, password }));
    tokenStore.set(data.tokens);
    return data.user;
  } catch (err) {
    throw normalizeError(err);
  }
};

export const me = async () => {
  try {
    return unwrap(await client.get("/auth/me"));
  } catch (err) {
    throw normalizeError(err);
  }
};

export const logout = async () => {
  const refreshToken = tokenStore.refresh;
  try {
    if (refreshToken) await client.post("/auth/logout", { refreshToken });
  } catch (e) {
    // best effort; clear locally regardless
  } finally {
    tokenStore.clear();
  }
};
